export default __webpack_public_path__ + "static/media/markovian.bb4a2c4a.png";